import { uiText, useAccountLocale } from '../../i18n';
import { useIdentityMerge } from './use-identity-merge';
import '../account/server-account.css';
export function IdentityMergeRecovery() {
  useAccountLocale();
  const merge = useIdentityMerge(async () => {
    location.reload();
  });
  return (
    <main className="server-account">
      <h1>{uiText('Объединение STEOS ID')}</h1>
      <p>
        {uiText(
          'Данные переносятся в подтверждённый аккаунт. Старые сессии закрыты; квитанция позволяет продолжить проверку после перезагрузки.',
        )}
      </p>
      <p role="status">{uiText(merge.state === 'completed' ? 'Обновляем вход…' : 'Проверяем состояние переноса…')}</p>
      {merge.error && <p role="alert">{uiText(merge.error)}</p>}
    </main>
  );
}
